import React, { Fragment } from 'react';
import { Script } from 'gatsby';

const RootElement = ({ children }) => {
  return (
    <Fragment>
         <Script
  src={`https://www.googletagmanager.com/gtm.js?id=GTM-KN2VKM`}
  strategy="off-main-thread"
  forward={[`dataLayer.push`]}
/>
<Script defer id="gtm-init" strategy="off-main-thread">
  {`
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' })
  `}
</Script>
      <div>{children}</div>
    </Fragment>
  );
};

export default RootElement;